// ---------------------------------------------------------------------------
// Reply rate — the one ratio the campaign screen shows
//
// It replaced a "Response" card that was `totalReplied / totalSent`, where
// `totalSent` counts emails only: "—" on every LinkedIn campaign, and replies
// from both channels over the emails alone on a cross-channel one. Markus asked
// what set it apart from "Replied"; the honest answer was nothing.
//
// Replied over contacted, both counted from the LEADS the page shows (T5
// review, 28 October). It used the campaign's `totalReplied`/`totalContacted`:
// replied there meant `repliedAt` only while the Replied card beside it counts
// chipPredicates.replied, and the 60-s auto-sync replaces the campaign with the
// stored document, whose counters are stale. Shown as a share (formatShare):
// 2 of 452 is "0.4%", not "0%". Nobody contacted yet is "—", not "0%": no rate
// has been measured.
// ---------------------------------------------------------------------------

import { formatShare } from './lead-funnel.js';
import { chipPredicates, type LeadStateChipInput } from './lead-state-chip.js';

/** The lead fields the rate reads. A subset of the page's LeadData. */
export interface ReplyRateLead extends LeadStateChipInput {
  sentAt?: string;
  lastContactedAt?: string;
}

/**
 * Reached on any channel: an email or an invitation (`sentAt`), a DM, any
 * recorded contact, our invitation — or a reply, which a lead cannot send
 * without having been reached, so the rate cannot pass 100 %.
 */
function wasContacted(l: ReplyRateLead): boolean {
  return !!l.sentAt || !!l.dmSentAt || !!l.lastContactedAt || chipPredicates.connSent(l) || chipPredicates.replied(l);
}

export function replyRate(leads: readonly ReplyRateLead[]): string {
  const contacted = leads.filter(wasContacted).length;
  if (contacted <= 0) return '—';
  return formatShare(leads.filter(chipPredicates.replied).length, contacted);
}
